<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';
</script>

<template>
    <div class="grid min-h-screen min-w-screen grid-cols-1 bg-white lg:grid-cols-2">
        <div
            class="bg-primary relative w-full overflow-hidden lg:fixed lg:top-0 lg:left-0 lg:grid lg:h-screen lg:w-1/2 lg:grid-rows-2"
        >
            <div class="h-full">
                <div class="relative h-full min-h-64 w-full lg:min-h-0">
                    <img
                        alt="Sign up hero"
                        class="absolute inset-0 h-full w-full object-cover object-center"
                        src="@/assets/images/login_platform.webp"
                    />
                </div>
            </div>
            <div class="hidden min-h-96 flex-col items-center justify-center text-white lg:flex">
                <div class="w-4/5">
                    <h2 class="font-sans text-white lg:text-3xl xl:text-4xl">
                        {{ $t('auth.sign_up_title') }}
                    </h2>
                    <ul
                        class="mt-8 flex flex-col gap-y-4 font-sans text-base font-normal text-white/40 lg:text-lg xl:text-xl"
                    >
                        <li class="flex items-center gap-x-2.5">
                            <CFIcon
                                name="arrow-right"
                                class="size-6"
                            />
                            {{ $t('auth.sign_up_usp1') }}
                        </li>
                        <li class="flex items-center gap-x-2.5">
                            <CFIcon
                                name="arrow-right"
                                class="size-6"
                            />
                            {{ $t('auth.sign_up_usp2') }}
                        </li>
                        <li class="flex items-center gap-x-2.5">
                            <CFIcon
                                name="arrow-right"
                                class="size-6"
                            />
                            {{ $t('auth.sign_up_usp3') }}
                        </li>
                        <li class="flex items-center gap-x-2.5">
                            <CFIcon
                                name="arrow-right"
                                class="size-6"
                            />
                            {{ $t('auth.sign_up_usp4') }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="text-primary relative flex min-h-full flex-col items-end justify-center bg-white lg:col-start-2">
            <div class="mx-auto w-full max-w-md py-8">
                <slot />
            </div>
        </div>
    </div>
</template>
